import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { GuideEngineService } from '../../services/guide-engine.service';
import { GuideTopLayerDirective } from '../../directives/guide-top-layer.directive';

/**
 * Floating playback control bar pinned bottom-center of the screen, visible
 * only while a walkthrough is active. Play/Pause, Previous/Next and Exit.
 *
 * State + behaviour live in {@link GuideEngineService}; this component is a thin
 * presentational surface (matches the sibling `launch-guide-button` pattern).
 */
@Component({
  selector: 'app-guide-controls',
  imports: [GuideTopLayerDirective],
  templateUrl: './guide-controls.html',
  styleUrl: './guide-controls.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuideControls {
  protected readonly engine = inject(GuideEngineService);

  protected readonly isActive = this.engine.isActive;
  protected readonly isPaused = this.engine.isPaused;
  protected readonly canPrevious = this.engine.canPrevious;
  protected readonly canNext = this.engine.canNext;
  protected readonly stepNumber = computed(() => this.engine.stepIndex() + 1);
  protected readonly totalSteps = this.engine.totalSteps;
}
